import { FC } from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn, Avatar, AvatarFallback, AvatarImage } from '@wellesley/ui'

const avatarVariants = cva('rounded-full', {
  variants: {
    size: {
      20: 'size-xxs text-xxs',
      24: 'size-xs text-xxs',
      32: 'size-s text-sm',
      40: 'size-m text-base',
      48: 'size-l text-base',
      64: 'size-xxl text-base',
      96: 'size-xxxl text-4xl',
    },
  },
  defaultVariants: {
    size: 40,
  },
})

export type UserAvatarProps = {
  name: string
  imgUrl?: string
  className?: string
  defaultIcon?: JSX.Element
  disabled?: boolean
} & VariantProps<typeof avatarVariants>

export const UserAvatar: FC<UserAvatarProps> = ({
  name,
  imgUrl,
  size = 40,
  className,
  defaultIcon,
  disabled,
}) => (
  <Avatar
    className={cn(avatarVariants({ size }), disabled && 'grayscale', className)}
    data-testid={`userAvatar-${size}`}
  >
    {imgUrl && <AvatarImage src={imgUrl} alt="user-avatar" />}
    <AvatarFallback className="bg-gray-700 text-white">
      {defaultIcon}
      {name?.[0]?.toUpperCase()}
    </AvatarFallback>
  </Avatar>
)
